import React, {useState, useEffect} from 'react'
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import { CardActions } from '@mui/material';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Button } from '@mui/material';
import { useMutation } from "react-query";
import apiClient from '../../request/http-common';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const EditWithdrawal = () => {
    const params = useParams();
    const [withdrawal, setWithdrawal] = useState(null);
    const { isLoading: isLoadingwithdrawal, refetch: getWithdrawal } = useQuery(
        "edit-withdrawal",
        async () => {
          return await apiClient.get(`/api/list-withdrawals`);
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                const withdrawalData = res.data.withdrawals.find(w => w.id == params.id);
                if (withdrawalData) {
                    setWithdrawal(withdrawalData);
                    setWithdrawalForm({
                        amount: withdrawalData.amount,
                        address: withdrawalData.address,
                        coin_name: withdrawalData.coin_name,
                        status: withdrawalData.status
                    });
                }
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

    const dispatch = useDispatch();
    
    const initialWithdrawal = {
        amount: '',
        address: '',
        coin_name: '',
        status: 'pending'
    }
    
    const [error, setErros] = useState('');
    const [withdrawalForm, setWithdrawalForm] = useState(initialWithdrawal);

    const onChange = (e) =>
    setWithdrawalForm({ ...withdrawalForm, [e.target.name]: e.target.value });


    const { isLoading: isSendingRequest, mutate: postWithdrawal } = useMutation(

        async () => {
          return await apiClient.post(`/api/update-withdrawal`, {
            withdrawal_id: params.id,
            amount: withdrawalForm.amount,
            address: withdrawalForm.address,
            coin_name: withdrawalForm.coin_name,
            withdrawal_status: withdrawalForm.status
          });
        },
        {
          onSuccess: (res) => {
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event2 = new Event('processed');
            window.dispatchEvent(event2);
          },
          onError: (err) => {   
            let myerror = err.response?.data || err;         
            setErros(myerror.errors || myerror.message)  
            const event2 = new Event('processed');
            window.dispatchEvent(event2);     
          },
        }
      );
      const onSubmit = () =>{
        const event3 = new Event('processing');
        window.dispatchEvent(event3);
        postWithdrawal();
      } 

      useEffect(() => {
        getWithdrawal();
      }, []);

  return (
    <div style={{marginTop: '70px'}}>
        {withdrawal !== null && 

        <Grid container px={2} mt={4}  mb={4} rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
        <Grid item xs={12} sm={12} md={8}>
            <Card sx={{background: 'linear-gradient(145deg, rgba(22, 26, 30, 0.8) 0%, rgba(31, 35, 41, 0.6) 100%)', border: '1px solid #2B3139'}}>
                <CardContent>
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                    Edit Withdrawal
                    </Typography>
                    <Typography variant="h5" component="div">
                        Withdrawal Details
                    </Typography>
                </CardContent>
                <Divider />
                <CardContent>
                    <Box sx={{ marginTop: 2, marginBottom: 2 }}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="amount">Amount</InputLabel>
                            <OutlinedInput
                            id="amount"
                            name="amount"
                            label="Amount"
                            type='number'
                            value={withdrawalForm.amount}
                            onChange={onChange}
                            />
                        </FormControl>
                    </Box>

                    <Box sx={{ marginTop: 2, marginBottom: 2 }}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="coin_name">Coin Name</InputLabel>
                            <OutlinedInput
                            id="coin_name"
                            name="coin_name"
                            label="Coin Name"
                            value={withdrawalForm.coin_name}
                            onChange={onChange}
                            />
                        </FormControl>
                    </Box>

                    <Box sx={{ marginTop: 2, marginBottom: 2 }}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="address">Address</InputLabel>
                            <OutlinedInput
                            id="address"
                            name="address"
                            label="Address"
                            value={withdrawalForm.address}
                            onChange={onChange}
                            />
                        </FormControl>
                    </Box>

                    <Box sx={{ marginTop: 2, marginBottom: 2 }}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="status">Status</InputLabel>
                            <Select
                                id="status"
                                name="status"
                                label="Status"
                                value={withdrawalForm.status}
                                onChange={onChange}
                            >
                                <MenuItem value="pending">Pending</MenuItem>
                                <MenuItem value="approved">Approved</MenuItem>
                                <MenuItem value="declined">Declined</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    {error && <Typography color="error" sx={{ marginTop: 2 }}>{JSON.stringify(error)}</Typography>}

                </CardContent>
                <Divider />
                <CardActions>
                    <Button 
                        component={RouterLink}
                        to="/list-withdrawals"
                        size="small" 
                        variant="outlined"
                    >
                        Back
                    </Button>
                    <Button disabled={isSendingRequest} onClick={onSubmit} size="small" variant="contained" color="primary">
                        {isSendingRequest ? <CircularProgress size={20} /> : 'Update'}
                    </Button>
                </CardActions>
            </Card>
        </Grid>
        </Grid>

        }
    </div>
  );
};

export default EditWithdrawal;
